<mat-toolbar color="primary">
  <a [routerLink]="['/home']"
    ><img
      alt="company logo"
      *ngIf="companyLogo$ | async"
      class="max-w-16 mr-2 max-h-12"
      src="{{ companyLogo$ | async }}"
  /></a>
  <a [routerLink]="['/home']"
    ><span *ngIf="companyName$ | async">{{ companyName$ | async }}</span></a
  >
  <a [routerLink]="['/home']"
    ><span *ngIf="(companyName$ | async) === undefined">Pegasus TIME</span></a
  >
  <span class="spacer"></span>
  <button mat-icon-button aria-label="settings" [routerLink]="['settings']">
    <mat-icon>settings</mat-icon>
  </button>
</mat-toolbar>
